import { createSlice } from '@reduxjs/toolkit';
import { sliceName } from '../../../constants';
import { vehicleRegistrationInitialState } from '../../initialStates';
var registerVehicleErrorSlice = createSlice({
    name: sliceName.registerVehicleErrorSliceName,
    initialState: vehicleRegistrationInitialState.vehicleDetailInitialErrorState,
    reducers: {
        setVehicleRegisterError: function (state, action) {
            state.isFirstNameError = action.payload.isFirstNameError;
            state.isLastNameError = action.payload.isLastNameError;
            state.isVehicleTypeError = action.payload.isVehicleTypeError;
            state.isMakeError = action.payload.isMakeError;
            state.isModelError = action.payload.isModelError;
            state.isYearError = action.payload.isYearError;
            state.isColorError = action.payload.isColorError;
            state.isLicensePlateError = action.payload.isLicensePlateError;
            state.isStateError = action.payload.isStateError;
            state.isRegistrationTypeError = action.payload.isRegistrationTypeError;
            state.isParkingLocationError = action.payload.isParkingLocationError;
            state.isPolicyCheckedError = action.payload.isPolicyCheckedError;
            state.isFormSubmit = action.payload.isFormSubmit;
            state.closeModal = action.payload.closeModal;
            state.isFuelTypeError = action.payload.isFuelTypeError;
            state.isContactNumberError = action.payload.isContactNumberError;
            state.isExpiryDateError = action.payload.isExpiryDateError;
        },
    },
});
export var setVehicleRegisterError = registerVehicleErrorSlice.actions.setVehicleRegisterError;
export var vehicleRegisterErrorReducer = registerVehicleErrorSlice.reducer;
